import { axios } from '@/utils/request'

// 预加载
export function getTemplatePre(parameter) {
  return axios({
    url: '/merchant.php/template/pre',
    method: 'get',
    params: parameter
  })
}

// 模板管理 - 模板列表
export function getTemplateList(parameter) {
  return axios({
    url: '/merchant.php/template/getList',
    method: 'get',
    params: parameter
  })
}

// 模板管理 - 模板详情
export function getTemplateDetail(parameter) {
  return axios({
    url: '/merchant.php/template/detail',
    method: 'get',
    params: parameter
  })
}

// 模板管理 - 新增模板
export function postTemplateAdd(data) {
  return axios({
    url: '/merchant.php/template/add',
    method: 'post',
    data: data
  })
}

// 模板管理 - 编辑模板
export function postTemplateEdit(data) {
  return axios({
    url: '/merchant.php/template/edit',
    method: 'post',
    data: data
  })
}

// 模板管理 - 删除模板
export function postTemplatesDel(data) {
  return axios({
    url: '/merchant.php/template/del',
    method: 'post',
    data: data
  })
}

// 订单预加载
export function getOrderPre(parameter) {
  return axios({
    url: '/merchant.php/order/pre',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 平台打印订单列表
export function getPlatformOrderList(parameter) {
  return axios({
    url: '/merchant.php/order/platformOrderList',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 自打印订单列表

export function getLocalOrderList(parameter) {
  return axios({
    url: '/merchant.php/order/localOrderList',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 创建打印订单
export function postOrderAdd(data) {
  return axios({
    url: '/merchant.php/order/add',
    method: 'post',
    data: data
  })
}

// 订单管理 - 创建重新打印订单
export function postReprintOrderAdd(data) {
  return axios({
    url: '/merchant.php/order/addReprintOrder',
    method: 'post',
    data: data
  })
}

// 订单管理 - 创建充值订单
export function postRechargeOrderAdd(data) {
  return axios({
    url: '/merchant.php/order/addRechargeOrder',
    method: 'post',
    data: data
  })
}
// 订单管理 - 创建年费订单
export function postAnnualOrderAdd(data) {
  return axios({
    url: '/merchant.php/order/addAnnualOrder',
    method: 'post',
    data: data
  })
}

// 订单管理 - 打印订单详情
export function getOrderDetail(parameter) {
  return axios({
    url: '/merchant.php/order/detail',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 查询重新打印订单详情
export function getReprintOrderDetail(parameter) {
  return axios({
    url: '/merchant.php/order/reprintOrderDetail',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 年费订单详情
export function getAnnualOrderDetail(parameter) {
  return axios({
    url: '/merchant.php/order/annualDetail',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 充值订单详情
export function getRechargeOrderDetail(parameter) {
  return axios({
    url: '/merchant.php/order/rechargeDetail',
    method: 'get',
    params: parameter
  })
}

// 订单管理 - 取消订单
export function postCancalOrder(data) {
  return axios({
    url: '/merchant.php/order/cancalOrder',
    method: 'post',
    data: data
  })
}

// 订单管理 - 打印订单确认收货
export function postOrderReceived(data) {
  return axios({
    url: '/merchant.php/order/received',
    method: 'post',
    data: data
  })
}

// 云码管理 - 云码列表
export function getCodeList(parameter) {
  return axios({
    url: '/merchant.php/security_code/getList',
    method: 'get',
    params: parameter
  })
}
// 云码管理 - 预加载
export function getCoderPre(parameter) {
  return axios({
    url: '/merchant.php/security_code/pre',
    method: 'get',
    params: parameter
  })
}

// 收货地址 - 地址列表
export function getAddressList(parameter) {
  return axios({
    url: '/merchant.php/address/getList',
    method: 'get',
    params: parameter
  })
}

// 收货地址 - 地址详情
export function getAddressDetail(parameter) {
  return axios({
    url: '/merchant.php/address/detail',
    method: 'get',
    params: parameter
  })
}

// 收货地址 - 删除地址
export function postDelAddress(data) {
  return axios({
    url: '/merchant.php/address/del',
    method: 'post',
    data: data
  })
}

// 收货地址 - 新增收货地址
export function postAddAddress(data) {
  return axios({
    url: '/merchant.php/address/add',
    method: 'post',
    data: data
  })
}

// 收货地址 - 编辑收货地址
export function postEditAddress(data) {
  return axios({
    url: '/merchant.php/address/edit',
    method: 'post',
    data: data
  })
}

// 订单管理 - 订单调起支付
export function postOrderPay(data) {
  return axios({
    url: '/merchant.php/order/pay',
    method: 'post',
    data: data
  })
}

// 订单管理 - 查询订单支付状态
export function queryPayResult(data) {
  return axios({
    url: '/merchant.php/order/queryPayResult',
    method: 'post',
    data: data
  })
}

// 资产信息 - 预加载
export function getPropertypre(parameter) {
  return axios({
    url: '/merchant.php/property/pre',
    method: 'get',
    params: parameter
  })
}

// 资产信息 - 获取商户信息
export function getTenant(parameter) {
  return axios({
    url: '/merchant.php/property/getTenant',
    method: 'get',
    params: parameter
  })
}

// 资产信息 - 订单列表
export function getPropertyOrderList(parameter) {
  return axios({
    url: '/merchant.php/property/getOrderList',
    method: 'get',
    params: parameter
  })
}

// 打印管理 - 打印云码
export function getOrderPrinterList(parameter) {
  return axios({
    url: '/merchant.php/printer/index',
    method: 'get',
    params: parameter
  })
}
